// components/Common/LogoutButton.jsx


import { ListItem, ListItemButton, ListItemText } from '@mui/material';
import api from '../../api/axios';
import { useUser } from '../../contexts/UserContext'; // ✅ 추가

const LogoutButton = () => {
  const { setUserInfo } = useUser(); // ✅ 유저 정보 초기화용

  const handleLogout = () => {
    if (!window.confirm('로그아웃 하시겠습니까?')) return;

    api.post('/api/accounts/logout/')
      .then(() => {
        setUserInfo(null); // ✅ 상태 초기화
        alert('로그아웃 되었습니다.');
        window.location.href = '/'; // ✅ 새로고침 방식으로 홈 이동 (세션 재요청 방지)
      })
      .catch(() => {
        alert('로그아웃 실패');
      });
  };

  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={handleLogout}
        sx={{ color: 'error.main', fontWeight: 'bold' }}
      >
        <ListItemText primary="🚪 로그아웃" />
      </ListItemButton>
    </ListItem>
  );
};

export default LogoutButton;
